import { config } from 'api';
import errorHandler from 'utils/errorHandler';

export const FETCH_META_DATA_REQUEST = 'FETCH_META_DATA_REQUEST';
export const FETCH_META_DATA_SUCCESS = 'FETCH_META_DATA_SUCCESS';
export const FETCH_META_DATA_ERROR = 'FETCH_META_DATA_ERROR';

const endpointUrl = `${config.apiBasePath}/seo`;

function requestMetaData() {
  return {
    type: FETCH_META_DATA_REQUEST,
  };
}

function receiveMetaData(data) {
  return {
    type: FETCH_META_DATA_SUCCESS,
    data,
  };
}

function receiveMetaDataError() {
  return {
    type: FETCH_META_DATA_ERROR,
  };
}

export function ensureMetaData() {
  return (dispatch, getState, { network }) => {
    const { meta } = getState();
    const shouldNotFetchMeta =
     !config.seoFromKaleEnabled || (meta && (meta.isReceived || meta.isFetching));

    if (shouldNotFetchMeta) {
      return Promise.resolve();
    }

    dispatch(requestMetaData());

    return network.get(endpointUrl)
      .then(data => dispatch(receiveMetaData(data)))
      .catch(err => {
        dispatch(receiveMetaDataError());
        errorHandler(err);
      });
  };
}
